import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 10L2 22h12z"
})), 'SignalCellular2Bar');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellular2Bar.js
// module id = 6143
// module chunks = 2